import Swiper from 'swiper/js/swiper';

jQuery(function() {

  if ($('.teacher-slider-container').length > 0) {
    let spaceBetween = 20,
      slidesOffsetAfter = 20;
    if (window.innerWidth > 576) { //$screen-sm-min
      spaceBetween = 50;
      slidesOffsetAfter = 50;
    }
    new Swiper('.teacher-slider-container', {
      slidesPerView: 'auto',
      loop: false,
      spaceBetween: spaceBetween,
      effect: 'slide',
      slidesOffsetAfter: slidesOffsetAfter,
      freeMode: true,
      freeModeSticky: true,
      navigation: {
        nextEl: '.teacher-slider-button-next',
        prevEl: '.teacher-slider-button-prev',
      },
    });
  }

});
